import { string } from "yup";

// \p{M} keeps Arabic diacritics (harakat) valid; `*` leaves empty values to `.required()`.
const PERSON_NAME_REGEX = /^[\p{L}\p{M} ]*$/u;

export const personNameSchema = (t, requiredMessage) =>
  string()
    .trim()
    .required(requiredMessage)
    .matches(PERSON_NAME_REGEX, t("common:customerNameInvalid"));
